function getAccessToken() {
  return localStorage.getItem('token')
}

function getChannel() {
  const query = new URLSearchParams(window.location.search)
  return query.get('channel') || ''
}

export interface HttpResponse {
  httpStatusCode: number
  json: any
}

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const validateExistingToken = async () => {
  const secondaryToken = new URLSearchParams(window.location.search).get('secondary_token')
  if (getChannel() === 'mobile' || secondaryToken) return true
  const accessToken = getAccessToken()
  if (accessToken) return true
  const uniqueVisitId = localStorage.getItem('visit-id')!
  const requestedTokenId = localStorage.getItem(`requested-token`)
  const isAlreadyRequestedToken = requestedTokenId === uniqueVisitId
  if (!isAlreadyRequestedToken) {
    console.log('sent request token at', new Date().toISOString())
    localStorage.setItem(`requested-token`, uniqueVisitId?.toString())
    localStorage.setItem('requested-new-token-at', new Date().getTime().toString())
    window.parent.postMessage('request-new-token', '*')
  }
  while(accessToken === localStorage.getItem('token')) {
    await wait(50)
  }
  return true
}

const isTokenError = async (response: HttpResponse) => {
  try {
    const isNeededRequestingBZBToken = 
    (response.httpStatusCode === 1905 && response.json?.error.error_detail[0].reasons === 'กรุณาลงชื่อเข้าใช้อีกครั้ง.') ||
    (response.httpStatusCode === 400 && response.json?.error.error_detail[0].reasons === 'bzb_token is required') ||
    (response.httpStatusCode === 412 && response.json?.error.error_detail[0].reasons === 'PreconditionFailed')
    const isNeededRequestingMyCouponToken = response.httpStatusCode === 401 && response.json?.error.error_detail[0].reasons === 'Unauthorized'
    if (isNeededRequestingMyCouponToken) {
      const accessToken = getAccessToken()
      window.parent.postMessage('request-new-token', '*')
      while(accessToken === localStorage.getItem('token')) {
        await wait(50)
      }
      return {is_bzb_error: false}
    } else if (isNeededRequestingBZBToken) {
      const bzbToken = localStorage.getItem('bzb_user_token')
      window.parent.postMessage('request-bzb-token', '*')
      while(bzbToken === localStorage.getItem('bzb_user_token')) {
        await wait(50)
      }
      return {is_bzb_error: true, bzb_token: bzbToken}
    }
  } catch (error) {
    console.error('Error checking token error:', error)
  }
  return false
}

const getParamsFromUrl = () => {
  // Create URLSearchParams object to access the query parameters
  const params = new URLSearchParams(window.location.search)

  // Retrieve specific parameters
  const channel = params.get('channel')
  const secondaryToken = params.get('secondary_token')

  return { channel, secondaryToken }
}

export const get = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }
  const { channel, secondaryToken } = getParamsFromUrl()

  options.method = 'GET'
  options.signal = controller.signal
  options.headers = { 
    ...options.headers, 
    Authorization: getAccessToken()!, 
    'Sub-Authorization': secondaryToken || '', 
    channel : channel || '' ,
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    const callbackerror = await isTokenError(responseObject)
    if (callbackerror) {
      if (callbackerror.is_bzb_error) {
        // set query parameter "bzb_token"
        const newUrl = new URL(url)
        newUrl.searchParams.set('bzb_token', callbackerror.bzb_token!)
        responseObject = await get(newUrl.toString(), options)
      } else {
        responseObject = await get(url.toString(), options)
      }
    }
    return responseObject
  } catch (e) {
    throw e
  }
}

export const post = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }

  const { channel, secondaryToken } = getParamsFromUrl()

  options.method = 'POST'
  options.signal = controller.signal
  options.headers = { 
    ...options.headers, 
    Authorization: getAccessToken()!, 
    'Sub-Authorization': secondaryToken || '', 
    channel : channel || '' ,
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }


    const callbackerror = await isTokenError(responseObject)
    console.log('recallOptions: ', options)
    if (callbackerror && options.body) {
      const previousRequestBody = JSON.parse(options.body as string)
      console.log(previousRequestBody)
      previousRequestBody.bzb_token = callbackerror.bzb_token
      options.body = JSON.stringify(previousRequestBody)
      console.log({
        options
      })
      responseObject = await post(url, options)
    }

    return responseObject
  } catch (e) {
    throw e
  }
}

export const del = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }
  const { channel, secondaryToken } = getParamsFromUrl()

  options.method = 'DELETE'
  options.signal = controller.signal
  options.headers = { 
    ...options.headers, 
    Authorization: getAccessToken()!, 
    'Sub-Authorization': secondaryToken || '', 
    channel : channel || '' ,
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    const callbackerror = await isTokenError(responseObject)
    if (callbackerror && options.body) {
      options.body = JSON.parse(options.body as string).bzb_token = callbackerror.bzb_token
      responseObject = await del(url, options)
    }

    return responseObject
  } catch (e) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const patch = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }
  const { channel, secondaryToken } = getParamsFromUrl()

  options.method = 'PATCH'
  options.signal = controller.signal
  options.headers = { 
    ...options.headers, 
    Authorization: getAccessToken()!, 
    'Sub-Authorization': secondaryToken || '', 
    channel : channel || '' ,
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    const callbackerror = await isTokenError(responseObject)
    if (callbackerror && options.body) {
      options.body = JSON.parse(options.body as string).bzb_token = callbackerror.bzb_token
      responseObject = await patch(url, options)
    }

    return responseObject
  } catch (e) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
